import React from "react";
import { Alert, Box, Button, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import DashboardLoadingState from "./DashboardLoadingState";

export default function OwnerRoute({ children }) {
  const { user, loading, refreshUser } = useAuth();
  const navigate = useNavigate();

  if (loading) {
    return <DashboardLoadingState label="Validando acceso Owner…" />;
  }

  if (user?.isPlatformOwner === true || ["owner", "superowner"].includes(user?.platformRole)) {
    return children;
  }

  return (
    <Box sx={{ maxWidth: 760, mx: "auto", py: { xs: 2, md: 6 } }}>
      <Alert severity="error" sx={{ mb: 2, borderRadius: 2.5 }}>
        Esta zona requiere acceso Owner de WebProfit.
      </Alert>
      <Typography variant="h5" sx={{ fontWeight: 950, mb: 1 }}>
        Acceso Owner requerido
      </Typography>
      <Typography sx={{ color: "text.secondary", mb: 2.5 }}>
        Tu usuario necesita estar habilitado como Owner. El superowner administra estos accesos desde Configuración.
      </Typography>
      <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
        <Button variant="contained" onClick={() => refreshUser()} sx={{ textTransform: "none", fontWeight: 900 }}>
          Volver a validar
        </Button>
        <Button variant="outlined" onClick={() => navigate("/dashboard")} sx={{ textTransform: "none", fontWeight: 900 }}>
          Volver al panel
        </Button>
      </Box>
    </Box>
  );
}
